import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import styles from './FeatureDetailSharing.module.scss';
import SharePanel from '../../SharePanel';
import { NOTEABLE_TYPES } from '../../../../lib/constants';

export const FeatureDetailSharing = (props) => {
  return (
    <div className={styles.shareContainer}>
      <SharePanel
        grantableId={props.selectedFeature.uuid}
        grantableType={NOTEABLE_TYPES.Feature}
        isOwner={props.selectedFeature.isOwner}
      />
    </div>
  );
};

FeatureDetailSharing.propTypes = {
  selectedFeature: PropTypes.object
};

export default connect(model => ({
  selectedFeature: model.features.selectedFeature
}))(FeatureDetailSharing);
